import React from 'react';

const Copy = ({ size = 30, color = 'currentColor', onClick }: { size?: number, color?: string, onClick?: () => void }) => {
  return <svg width={size} height={size} viewBox="0 0 28 30" fill="none" xmlns="http://www.w3.org/2000/svg"
              onClick={onClick}>
    <path
      d="M22.2842 23.7991H22.659C24.9137 23.7991 26.3762 22.5569 26.3762 19.9549V8.895H19.8113C18.6125 8.895 17.8831 8.16562 17.8831 6.9764V0H11.5885C9.13787 0 7.79749 1.33078 7.79749 3.74413V4.30453H9.59584C11.4115 4.30453 12.7547 4.72804 14.0588 6.03L20.7108 12.6745C21.9875 13.9587 22.2842 15.4003 22.2842 17.1312V23.7991ZM20.1183 7.32469H26.1891C26.139 6.92438 25.8474 6.56883 25.4035 6.1186L20.649 1.24922C20.2273 0.802031 19.858 0.514688 19.463 0.472032L19.4726 6.65766C19.4726 7.12547 19.6505 7.32469 20.1183 7.32469Z"
      fill={color}/>
    <path
      d="M5.80577 29.8092H16.775C19.2851 29.8092 20.5808 28.4848 20.5808 25.965V16.8675H12.2471C10.748 16.8675 10.0196 16.1294 10.0196 14.6379V6.01007H5.80577C3.30523 6.01007 2 7.3228 2 9.85428V25.965C2 28.4965 3.29562 29.8092 5.80577 29.8092ZM12.3619 15.1544L20.3614 15.1502C20.2337 14.6552 19.9325 14.1827 19.3925 13.6331L13.2212 7.36358C12.6887 6.81937 12.2244 6.45515 11.723 6.30726V14.5167C11.723 14.9362 11.9466 15.1544 12.3619 15.1544Z"
      fill={color}/>
  </svg>;
};

export default Copy;
